import "../App.css";
import ChatPanel from "../components/chat/ChatPanel";

function Chat() {
  return <ChatPanel />;
}

export default Chat;
